import defaultLogo from 'assets/images/logo.png';
import clientALogo from 'assets/images/aquazeel-logo.png';
import clientBLogo from 'assets/images/zazmic-connect-logo.png';

import {
  TENANT_FEATURES,
  TENANT_MENU_ITEMS,
  TENANT_PAGE_ENTRY_POINTS,
  TENANT_ROUTES,
  TENANT_TABS,
} from '../features';
import { TenantConfig } from '../types';

const publicUrl = process.env.PUBLIC_URL || '';

export const mockTenantConfigs: Record<string, TenantConfig> = {
  zazmic: {
    id: 'zazmic',
    key: 'zazmic',
    hostnames: ['portal.zazmic.com', 'stg.portal.zazmic.com', 'localhost'],
    branding: {
      appName: 'Zazmic Connect',
      productName: 'Zazmic-Connect',
      companyName: 'Zazmic',
      legalEntityName: 'Zazmic, Inc.',
      supportEmail: 'support@zazmic.com',
      financeEmail: 'finance@zazmic.com',
      billingAddressLines: [
        '416 Mission St, Suite 3700,',
        'San Francisco, US CA 94105',
      ],
      discountLabel: 'Zazmic Discount',
      securityCookieDomain: 'zazmic.com',
      logoUrl: defaultLogo,
      faviconUrl: `${publicUrl}/favicon.ico`,
      colors: {
        primary: '#6F9FE9',
        secondary: '#2B6CB0',
        button: '#6F9FE9',
        borderAccent: '#fc3636',
      },
    },
    urls: {
      portal: {
        staging: 'https://stg.portal.zazmic.com',
        production: 'https://portal.zazmic.com',
      },
      observability: {
        staging: 'https://observability.zazmic.com',
        production: 'https://observability.zazmic.com',
      },
      security: {
        staging: 'https://security.zazmic.com/dashboard',
        production: 'https://security.zazmic.com/dashboard',
      },
    },
    features: {},
    visibility: {
      routes: {
        [TENANT_ROUTES.helpCenter]: true,
      },
      menuItems: {
        [TENANT_MENU_ITEMS.helpCenter]: true,
      },
      tabs: {},
      pageEntryPoints: {},
    },
    pdfBranding: {},
  },
  aquazeel: {
    id: 'aquazeel',
    key: 'aquazeel',
    hostnames: ['aconnect.aquazeel.com', 'stg.aconnect.aquazeel.com'],
    branding: {
      appName: 'Aconnect',
      productName: 'Aconnect',
      companyName: 'Aquazeel',
      legalEntityName: 'Aquazeel',
      supportEmail: 'support@aquazeel.com',
      financeEmail: 'finance@aquazeel.com',
      discountLabel: 'Aquazeel Discount',
      logoUrl: clientALogo,
      faviconUrl: `${publicUrl}/aquazeel-favicon.png`,
      colors: {
        primary: '#0173CC',
        secondary: '#0173CC',
        button: '#0173CC',
        text: '#000000',
        accent: '#0173CC',
        borderAccent: '#6F9FE9',
      },
      typography: {
        primaryFontFamily: '"Inter Tight", sans-serif',
        primaryFontWeight: 500,
        secondaryFontFamily: '"Inter Tight", sans-serif',
        secondaryFontWeight: 400,
        textFontFamily: '"Inter Tight", sans-serif',
        textFontWeight: 500,
        accentFontFamily: 'Roboto, sans-serif',
        accentFontWeight: 500,
      },
    },
    urls: {
      portal: {
        staging: 'https://stg.aconnect.aquazeel.com',
        production: 'https://aconnect.aquazeel.com',
      },
      api: {
        staging: 'https://stg.api.aconnect.aquazeel.com/',
        production: 'https://api.aconnect.aquazeel.com',
      },
      observability: {
        staging: 'https://stg.aconnect.aquazeel.com',
        production: 'https://aconnect.aquazeel.com',
      },
      security: {
        staging: 'https://stg.aconnect.aquazeel.com',
        production: 'https://aconnect.aquazeel.com',
      },
    },
    features: {
      [TENANT_FEATURES.reports]: true,
      [TENANT_FEATURES.billing]: false,
      [TENANT_FEATURES.companyProjectInvoicing]: true,
      [TENANT_FEATURES.companyExpenseReport]: true,
    },
    visibility: {
      routes: {
        [TENANT_ROUTES.helpCenter]: false,
        [TENANT_ROUTES.reports]: true,
        [TENANT_ROUTES.payment]: false,
      },
      menuItems: {
        [TENANT_MENU_ITEMS.helpCenter]: false,
        [TENANT_MENU_ITEMS.reports]: true,
        [TENANT_MENU_ITEMS.payment]: false,
      },
      tabs: {
        [TENANT_TABS.companyProjectInvoicing]: true,
        [TENANT_TABS.companySalesRep]: false,
        [TENANT_TABS.companyExpenseReport]: true,
      },
      pageEntryPoints: {
        [TENANT_PAGE_ENTRY_POINTS.openInvoicesPaymentSettings]: false,
      },
    },
    pdfBranding: {},
  },
  default: {
    id: 'default',
    key: 'default',
    branding: {
      appName: 'Zazmic Connect',
      productName: 'Zazmic-Connect',
      companyName: 'Zazmic',
      legalEntityName: 'Zazmic, Inc.',
      supportEmail: 'support@zazmic.com',
      financeEmail: 'finance@zazmic.com',
      billingAddressLines: [
        '416 Mission St, Suite 3700,',
        'San Francisco, US CA 94105',
      ],
      discountLabel: 'Zazmic Discount',
      securityCookieDomain: 'zazmic.com',
      logoUrl: clientBLogo,
      faviconUrl: `${publicUrl}/favicon.ico`,
      colors: {
        primary: '#6F9FE9',
        secondary: '#2B6CB0',
        button: '#6F9FE9',
        borderAccent: '#fc3636',
      },
    },
    urls: {
      portal: {
        staging: 'https://stg.portal.zazmic.com',
        production: 'https://portal.zazmic.com',
      },
    },
    features: {},
    visibility: {
      routes: {
        [TENANT_ROUTES.helpCenter]: true,
      },
      menuItems: {
        [TENANT_MENU_ITEMS.helpCenter]: true,
      },
      tabs: {},
      pageEntryPoints: {},
    },
    pdfBranding: {},
  },
};
